import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  titulo: {
    fontSize: '1.25rem !important',
    fontWeight: '500 !important',
    lineHeight: '2rem !important'
  },
  subTitulo: {
    fontSize: '0.875rem !important',
    color: '#616161',
    lineHeight: '1.375rem !important',
    fontWeight: '500 !important'
  },
  confirmedTitulo: {
    fontWeight: '500 !important', 
    fontSize: '1rem !important', 
    lineHeight: '1.6rem !important'
  },
  buttonCancelar:{
    color: '#616161 !important'
  },
  buttonSalvar:{
    background: '#2813AD !important', 
    color: '#FFFFFF !important', 
    padding: '0.5rem !important'
  },
  gridButtons:{
    display: 'flex', 
    justifyContent: 'space-between'
  }
}));